import { useState, useEffect } from "react";
import RoleBasedLayout from "./RoleBasedLayout";
import LeaveTracking from "../ui/LeaveTracker";
import Attendance from "../ui/Attendance";
import {
  SquareAsterisk, ChartBarStacked, Badge
} from "lucide-react";

export default function LeaveAndAttendance() {
  const [activeTab, setActiveTab] = useState("attendance");

  return (
    <RoleBasedLayout>
      <div className="relative h-[90.7vh]  overflow-y-auto">
        <div className="flex border-b border-gray-200 ">
          <button
            onClick={() => setActiveTab("attendance")}
            className={`px-4 py-2 font-medium rounded-t-lg text-[12px] lg:text-sm ${activeTab === "attendance"
              ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
              : "text-gray-500 hover:text-blue-500"
              }`}
          >
            <div className="flex gap-1 items-center">
              <SquareAsterisk size={18} />
              <span>Attendance</span>
            </div>
          </button>

          <button
            onClick={() => setActiveTab("leaves")}
            className={`px-4 py-2 font-medium rounded-t-lg text-[12px] lg:text-sm ${activeTab === "leaves"
              ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600"
              : "text-gray-500 hover:text-blue-500"
              }`}
          >
            <div className="flex gap-1 items-center">
              <Badge size={18} />
              <span>Leaves</span>
            </div>
          </button>

          {/* <button
            onClick={() => setActiveTab("time")}
            className={`px-4 py-2 font-medium ${activeTab === "time"
              ? "border-b-2 border-blue-500 text-blue-600 "
              : "text-gray-500 hover:text-blue-500"
              }`}
          >
            <div className="flex gap-1 items-center">
              <ChartBarStacked size={18} />
              <span> Employee</span>
            </div>
          </button> */}
        </div>

        {activeTab === "attendance" && (
          <div className="space-y-6 p-2 sm:p-6">
            <Attendance />
          </div>
        )}

        {activeTab === "leaves" && (
          <div className="space-y-2 p-2 sm:p-6">
            <LeaveTracking />
          </div>
        )}
        {/* 
        {activeTab === "time" && (
          <div className="space-y-2 p-6">
            {canViewAttendance ? <Employees /> : <TimeTracker />}
          </div>
        )} */}

      </div>
    </RoleBasedLayout>
  );
}
